const shared = require('./i18n.shared.js')

const HttpBackend = require('i18next-http-backend/cjs');
const LocalStorageBackend = require('i18next-localstorage-backend').default;

const isBrowser = typeof window !== 'undefined';

const path = !isBrowser ? require('path') : false;

const localePath = path !== false ? `${path.resolve('./public/locales')}/` : 'locales';

module.exports = {
  i18n: {
    defaultLocale: shared.fallbackLng,
    locales: shared.supportedLngs,
    localeDetection: /** @type {const} */ (false),
    ns: ['common'],
    defaultNS: 'common',
    lng: 'en',
    use: typeof window !== 'undefined' ? [HttpBackend] : [require('i18next-fs-backend/cjs')],
  },
  // Temporarily keep the interface in English, including existing localized URLs.
  supportedLngs: [shared.fallbackLng],
  debug: process.env.NODE_ENV === 'development',
  localePath,
  preload: ['en'],
  partialBundledLanguages: true,
  react: {
    useSuspense: false,
  },
  serializeConfig: false,
  detection: {
    order: [],
    caches: [],
  },
  resources: {
    en: {
      common: require('./public/locales/en/common.json'),
    },
    ...(process.env.NODE_ENV === 'development'
      ? {
        ru: {
          common: require('./public/locales/ru/common.json'),
        },
        es: {
          common: require('./public/locales/es/common.json'),
        },
      }
      : {}),
  },
  backend: {
    backendOptions: [
      {
        //loadPath: `${localePath}/{{lng}}/{{ns}}.json`,
        loadPath: `https://cdn.simplelocalize.io/0b07b3e8a33e443fb438c23f5ca716e8/_latest/{{lng}}/{{ns}}`,
      }
    ],
    loadPath: `https://cdn.simplelocalize.io/0b07b3e8a33e443fb438c23f5ca716e8/_latest/{{lng}}/{{ns}}`,
    backends: typeof window !== 'undefined' ? [HttpBackend] : [require('i18next-fs-backend/cjs')],
  },
}
